/**
 * Cloudlift Checkbox Handler (Clean Properties)
 * ---------------------------------------------
 * Main product gets all meaningful properties (filtered).
 * Extra product gets only Design + Line 1 + Line 2.
 */

document.addEventListener('DOMContentLoaded', () => {
  observeDOMForCheckboxOption();
});

function observeDOMForCheckboxOption() {
  const observer = new MutationObserver(() => {
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const checkbox = document.querySelector('input[type="checkbox"][value="yes"].cl-po--input');
    const variantInput = document.querySelector('input[name="properties[_option_include_product_id]"]');

    if (productForm && checkbox && variantInput && !productForm.dataset.checkboxHandlerBound) {
      productForm.dataset.checkboxHandlerBound = 'true';
      interceptFormSubmission(productForm, checkbox, variantInput);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function interceptFormSubmission(form, checkbox, variantInput) {
  const submitBtn = form.querySelector('[type="submit"]');

  form.addEventListener(
    'submit',
    (e) => {
      if (!checkbox?.checked) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const extraVariantId = variantInput?.value;

      if (!mainVariantId || !extraVariantId) {
        console.warn('🟠 Missing variant ID(s):', { mainVariantId, extraVariantId });
        return;
      }

      const allProps = extractAllProperties(formData);
      const filteredMainProps = filterMainProductProperties(allProps);
      const extraProps = filterExtraItemProperties(allProps);

      const payload = {
        items: [
          {
            id: Number(mainVariantId),
            quantity: 1,
            properties: filteredMainProps,
          },
          {
            id: Number(extraVariantId),
            quantity: 1,
            properties: extraProps,
          },
        ],
      };

      console.log('%c📦 Sending Items to Cart:', 'font-size:14px;color:#2c3e50;font-weight:bold;', payload);

      disableAddToCartBtn(submitBtn, 'Adding...');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((data) => {
          if (window.cartDrawer) {
            window.cartDrawer.renderContents(data);

          } else if (window.cartNotification) {
            window.cartNotification.renderContents(data);
          }
        })
        .catch((err) => {
          console.error('🛑 Add-to-cart failed:', err);
          alert('Something went wrong. Please try again.');
        })
        .finally(() => {
          enableAddToCartBtn(submitBtn, 'Add to Cart');
        });
    },
    { capture: true }
  );
}

function extractAllProperties(formData) {
  const props = {};
  for (const [key, value] of formData.entries()) {
    if (key.startsWith('properties[') && value.trim()) {
      const rawKey = key.replace(/^properties\[/, '').replace(/\]$/, '');

      if (rawKey.startsWith('_')) {
        props[rawKey] = value.trim();
      } else {
        props[formatLabel(rawKey)] = value.trim();
      }
    }
  }
  return props;
}

function filterMainProductProperties(props) {

  const excludedKeys = [
    'Option Include Product',
    'Include Product ID',
    'Cl Options',
  ];
  const filtered = {};
  for (const key in props) {
    if (!excludedKeys.includes(key)) {
      filtered[key] = props[key];
    }
  }
  return filtered;
}

function filterExtraItemProperties(allProps) {
  const filtered = {};

  console.log(allProps);

  for (const [key, value] of Object.entries(allProps)) {
    if (key === 'Design' || key === 'Line 1' || key.startsWith('Line 2')) {
      filtered[key] = value;
    }
  }

  return filtered;
}

function formatLabel(str) {
  return str
    .replace(/^_option_/, '') // remove _option_ prefix
    .replace(/^option_line_/, 'Line ')
    .replace(/_/g, ' ')
    .replace(/\bid\b/i, 'ID')
    .replace(/\b\w/g, (match) => match.toUpperCase()) // capitalize each word
    .trim();
}

function disableAddToCartBtn(button, loadingText = 'Adding...') {
  button.disabled = true;
  const span = button.querySelector('span');
  if (span) {
    span.dataset.originalText = span.innerText;
    span.innerText = loadingText;
  }
}

function enableAddToCartBtn(button, defaultText = 'Add to Cart') {
  button.disabled = false;
  const span = button.querySelector('span');
  if (span) {
    span.innerText = span.dataset.originalText || defaultText;
    delete span.dataset.originalText;
  }
}
